import React, { type ReactNode } from 'react'
import "./Results.css";

interface IProps {
	id: string;
	label?: ReactNode;
	value?: string | null;
	className?: string;
	unit?: ReactNode;
}

const Result: React.FC<IProps> = (props: IProps) => {
	return (
		<div className={"result-wrapper " + (props.className ?? "")} id={props.id}>
			<div className={"result-value " + (props.value ? "has-value" : "no-value")}>
				<b>{props.value ?? "0"}</b>
			</div>
			{props.unit &&
				<div className="result-label">
					{/* {props.label}{props.unit && <span> ({props.unit})</span>} */}
					{<span>{props.unit}</span>}
				</div>
			}
		</div>
	)
}

export default Result;
